import { User } from '@/types/user';
import { IntegrationManager, Integration } from './types';

export const createIntegrationManager = (
  integrations: ReadonlyArray<Integration>
): IntegrationManager => {
  const identityIntegrations = integrations.filter(
    integration => integration.identify || integration.reset
  );
  const analyticsIntegrations = integrations.filter(
    integration => integration.track
  );

  const identify = (user: User): void => {
    identityIntegrations.forEach(integration => {
      if (!integration.identify) return;

      try {
        integration.identify(user);
      } catch (error) {
        // Log error but don't throw - user identification in one integration
        // should not prevent identification in other integrations
        console.error(
          `[Integration] Failed to identify user in ${integration.name}:`,
          error
        );
      }
    });
  };

  const reset = (): void => {
    identityIntegrations.forEach(integration => {
      if (!integration.reset) return;

      try {
        integration.reset();
      } catch (error) {
        // Log error but don't throw - allow other integrations to reset
        console.error(
          `[Integration] Failed to reset ${integration.name}:`,
          error
        );
      }
    });
  };

  const track = (event: string, payload?: Record<string, any>): void => {
    analyticsIntegrations.forEach(integration => {
      if (!integration.track) return;

      try {
        integration.track(event, payload);
      } catch (error) {
        // Log error but don't throw - tracking is fire-and-forget
        // and should never interrupt the user's workflow
        console.error(
          `[Integration] Failed to track event "${event}" in ${integration.name}:`,
          error
        );
      }
    });
  };

  return Object.freeze({ identify, reset, track });
};
